// extracted by mini-css-extract-plugin
module.exports = {"newUIMenuWrapper":"WidgetsHeader__newUIMenuWrapper--gIO","newUIMenuContainer":"WidgetsHeader__newUIMenuContainer--1Ny","active":"WidgetsHeader__active--pVb"};